import {connect} from 'react-redux';

import {ResolveDispatchProps} from '../../../../../../../../../src/helpers/reduxHelpers';
import {CollapsedItemKeyPrefixesEnum} from '../../../../../../../../../src/models/api/localPreferencesModel';
import {uploadAccountsCSVAsyncAction} from '../../../../../../../../../src/store/data/accounts/accountsActions';
import {getCustomFieldsForAccounts} from '../../../../../../../../../src/store/data/customFields/customFieldsSelectors';
import {toggleExpandItemAction} from '../../../../../../../../../src/store/data/localPreferences/localPreferencesActions';
import {getFindIsExpanded} from '../../../../../../../../../src/store/data/localPreferences/localPreferencesSelectors';
import {getIsUserGlobalAdmin} from '../../../../../../../../../src/store/data/teammates/teammatesSelectors';
import {NavigationBlockerId} from '../../../../../../../../../src/store/panels/app/appPanelHelpers';
import {makeGetAccountsCSVFileState} from '../../../../../../../../../src/store/panels/contacts/contactsManager/contactsManagerPanelSelectors';
import {
  contactsManagerClearFileAction,
  contactsManagerFetchCsvMetadataAsyncAction,
  contactsManagerImportAccountsCSVAsyncAction,
  contactsManagerSetMappingAction,
  contactsManagerUploadAccountsCSVAsyncAction,
} from '../../../../../../../../../src/store/panels/contacts/contactsManager/file/contactsManagerFileStateActions';
import {ContactsManagerPanelId} from '../../../../../../../../../src/store/panels/panelStateBase';
import {navigateToLinkAction} from '../../../../../../../../../src/store/stateless/navigationActions';
import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
  ResolveStateProps,
} from '../../../../../../../../../srcCommon/helpers/reselectHelpers';
import {AccountsCsvImport} from './accountsCsvImport';

/*
 * Constants.
 */

const infoBoxExpandedKey = `${CollapsedItemKeyPrefixesEnum.IMPORT_ACCOUNTS_CSV}infoBox`;
const isInfoBoxExpandedDefault = true;

/*
 * Selectors.
 */

const getIsInfoBoxExpanded = createSelector([getFindIsExpanded], (findIsExpanded) =>
  findIsExpanded(infoBoxExpandedKey, isInfoBoxExpandedDefault),
);

/*
 * Props.
 */

interface AccountsCsvImportContainerPublicProps {
  panelId: ContactsManagerPanelId;
}

type AccountsCsvImportContainerStateProps = ResolveStateProps<typeof mapStateToProps>;
type AccountsCsvImportContainerDispatchProps = ResolveDispatchProps<typeof mapDispatchToProps>;
export type AccountsCsvImportContainerProps = AccountsCsvImportContainerPublicProps &
  AccountsCsvImportContainerStateProps &
  AccountsCsvImportContainerDispatchProps;

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  isInfoBoxExpanded: getIsInfoBoxExpanded,
  isUserGlobalAdmin: getIsUserGlobalAdmin,
  fileState: makeGetAccountsCSVFileState(),
  customFieldsForAccounts: getCustomFieldsForAccounts,
}));

const mapDispatchToProps = makeMapDispatchToProps<AccountsCsvImportContainerPublicProps>()(({panelId}) => ({
  navigateToLink: navigateToLinkAction,
  onClearFile: contactsManagerClearFileAction,
  onSetMapping: contactsManagerSetMappingAction,
  onCreateCustomField: () => contactsManagerFetchCsvMetadataAsyncAction(panelId),
  onImportAccounts: (ignoreNavigationBlockerId: NavigationBlockerId) =>
    contactsManagerImportAccountsCSVAsyncAction(panelId, ignoreNavigationBlockerId),
  onUploadAccountsCSV: (file) => contactsManagerUploadAccountsCSVAsyncAction(panelId, file),
  generateWarningFileAsync: (file, mapping) => {
    if (file) {
      return uploadAccountsCSVAsyncAction(file, true, mapping);
    }
    return undefined;
  },
  onToggleInfoBox: () => toggleExpandItemAction(infoBoxExpandedKey, isInfoBoxExpandedDefault),
}));

export const AccountsCsvImportContainer = connect(mapStateToProps, mapDispatchToProps)(AccountsCsvImport);
